import React, { useRef, useEffect, useState } from 'react';
import '../updatehackinginternship/Assets/PlacementAssets/Placements.css';

// --- Imports from your new component ---
import Borderline from '../updatehackinginternship/Assets/PlacementAssets/border.png';
import leftArrow from '../updatehackinginternship/Assets/PlacementAssets/previous.png';
import rightArrow from '../updatehackinginternship/Assets/PlacementAssets/next.png';

// --- Company logo imports (kept from your new component) ---
import Nestle from '../updatehackinginternship/Assets/PlacementAssets/nestle.png';
import Clazar from '../updatehackinginternship/Assets/PlacementAssets/clazar.png';
import Unilever from '../updatehackinginternship/Assets/PlacementAssets/unilever.png';
import Maggi from '../updatehackinginternship/Assets/PlacementAssets/maggi.png';

// --- Imports from your backend logic ---
import GetPlacedStudents from '../../actions/GetPlacedStudents';
import Localbase from 'localbase';
// import AnimatePage from '../../actions/animations/AnimatePage'; // Kept commented, as your new component has its own animations

// This array holds the UI-specific data (logos, colors) that is
// not available from your backend. We'll cycle through this.
const displayExtras = [
  { companyLogo: Clazar, bgColor: "#E87722" },
  { companyLogo: Nestle, bgColor: "#F6C643" },
  { companyLogo: Unilever, bgColor: "#3FA9F5" },
  { companyLogo: Maggi, bgColor: "#3CB371" },
  { companyLogo: Maggi, bgColor: "#3CB371" },
  { companyLogo: Clazar, bgColor: "#E87722" },
  { companyLogo: Nestle, bgColor: "#F6C643" },
  { companyLogo: Unilever, bgColor: "#3FA9F5" },
];

// --- DUMMY MENTORS ARRAY REMOVED ---

const Placements = () => {
  const scrollRef = useRef(null);
  const [autoScroll, setAutoScroll] = useState(true);
  const db = new Localbase('db');
  const [loading, setloading] = useState(false);
  const [query, setquery] = useState(null);

  const [limit, setlimit] = useState(12);
  const [totalvideos, settotalvideos] = useState(null);
  const [nomore, setnomore] = useState(false);
  const [videos, setvideos] = useState(null); // This will hold our backend data
  const [suggestions, setsuggestions] = useState(null);

  // --- Data fetching functions from backend code ---
  useEffect(() => {
    // AnimatePage() // Removed, as new component has CSS animations
    NewVideos();
    Getofflinedata();
  }, []);

  const NewVideos = async () => {
    setloading(true);

    const res = await GetPlacedStudents(
      query ? { payload: { limit: limit, query: query } } : { payload: { limit: limit } }
    );

    if (res) {
      setloading(false);
    }
    if (res.status === "success") {
      setvideos(res.data);
      db.collection('paths').add({ videos: res.data }, "videos");

      if (res.videos) {
        if (res.videos.length === res.total_videos) {
          setnomore(true);
        }
        settotalvideos(res.videos.length);
      }
      setsuggestions(res.suggestions);
      // AnimatePage() // Removed
    }
  };

  const Getofflinedata = () => {
    db.collection('paths').doc('videos').get().then((data) => {
      if (data && data.videos) {
        setvideos(data.videos);
      }
    }).catch((error) => { console.error("Error fetching offline data:", error); });
  };



  const scrollLeft = () => {
    const el = scrollRef.current;
    if (!el) return;

    const card = el.querySelector('.cards-inner-wrapper');
    if (!card) return;

    const cardWidth = card.clientWidth;
    const distance = window.innerWidth <= 768 ? cardWidth : 350;
    el.scrollBy({ left: -distance, behavior: 'smooth' });
  };

  const scrollRight = () => {
    const el = scrollRef.current;
    if (!el) return;

    const card = el.querySelector('.cards-inner-wrapper');
    if (!card) return;

    const cardWidth = card.clientWidth;
    const distance = window.innerWidth <= 768 ? cardWidth : 350;
    el.scrollBy({ left: distance, behavior: 'smooth' });
  };

  // Auto carousel effect
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollInterval: NodeJS.Timeout;

    const startAutoScroll = () => {
      const firstCard = scrollContainer.querySelector('.cards-inner-wrapper');
      if (!firstCard) return;

      const cardWidth = firstCard.clientWidth;

      scrollInterval = setInterval(() => {
        if (!autoScroll) return;

        const atEnd =
          scrollContainer.scrollLeft + scrollContainer.clientWidth >=
          scrollContainer.scrollWidth - 1;

        if (atEnd) {
          scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          const step = window.innerWidth <= 768 ? cardWidth : 350;
          scrollContainer.scrollBy({ left: step, behavior: 'smooth' });
        }
      }, 2700);
    };

    startAutoScroll();

    const handleMouseEnter = () => setAutoScroll(false);
    const handleMouseLeave = () => setAutoScroll(true);

    scrollContainer.addEventListener('mouseenter', handleMouseEnter);
    scrollContainer.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      clearInterval(scrollInterval);
      scrollContainer.removeEventListener('mouseenter', handleMouseEnter);
      scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [autoScroll]);

  return (
    <div className="placements-container">
      <div className="placements-header">
        {/* <div className="header-desc">
          <h6 className='clr-siliconMinds-orng'>Learn, Grow, and Connect with Experts</h6>
        </div>
        <div className="header-title">
          <h2>Comprehensive Training from Industry’s Top Mentors</h2>
          <img src={Borderline} alt="borderline" className="borderline-img" />
        </div> */}
        {/* <div className="header-subtitle">
    Prepare yourself to excel from Day 1 with guidance from 100+ internal and
    external professionals<br />
    who have years of experience working with leading organizations and
    teaching at top institutions.
  </div> */}
      </div>



      {/* Carousel section */}
      <div className="carousel-container">
        <button className="scroll-btn left" onClick={scrollLeft}>
          <img src={leftArrow} alt="left" />
        </button>

        <div className="cards-wrapper" ref={scrollRef}>
          {/* --- JSX UPDATED TO USE 'videos' STATE --- */}
          {loading && !videos && <p>Loading...</p> /* Added a loading state */}

          {videos && videos.concat(videos).map((item, i) => {
            // Get the corresponding display extras (logo, color)
            // Use modulo operator (%) to loop back to the start of the extras array
            const displayData = displayExtras[i % displayExtras.length];

            return (
              <div className="cards-inner-wrapper" key={i}>
                <div
                  className="mentor-img"
                  style={{ backgroundColor: displayData.bgColor, marginBottom: '-45px' }}
                >
                  {/* Use data from backend 'item' */}
                  <img src={`https://admin.siliconmindstechnologies.com/${item.image}`} alt={item.full_name} />
                </div>
                <div className="mentor-card">
                  <div className="mentor-card-content">
                    <div className="mentor-info">
                      {/* Use data from backend 'item' */}
                      <h4 className="mentor-name-new ">{item.full_name}</h4>
                      <p className="mentor-role clr-siliconMinds-orng">{item.role}</p>

                    </div>
                  </div>
                  <div className="company-experience">
                    <div className="company-logo-wrapper">
                      {/* Use data from 'displayData' */}
                      <img
                        src={`https://admin.siliconmindstechnologies.com/${item.company_url}`}
                        alt="company logo"
                        className="company-logo"
                      />
                      {/* <h4 className="mentor-name-new ">{item.company}</h4> */}
                    </div>

                    <p
                      className="mentor-ex"
                      style={{
                        fontWeight: 'bold',
                        fontSize: '0.95rem',
                        color: '#1a1a1a'
                      }}
                    >
                      {/* Format 'package' data from backend 'item' */}
                      {item.package} LPA
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <button className="scroll-btn right" onClick={scrollRight}>
          <img src={rightArrow} alt="right" />
        </button>
      </div>

      {/* ✅ Mobile controls below carousel */}
      <div className="mobile-controls">
        <button className="scroll-btn mobile-left" onClick={scrollLeft}>
          <img src={leftArrow} alt="left" />
        </button>
        <button className="scroll-btn mobile-right" onClick={scrollRight}>
          <img src={rightArrow} alt="right" />
        </button>
      </div>
    </div>
  );
};

export default Placements;